import { Button, Grid, Group, Modal, Stack, Text, Tooltip, UnstyledButton } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useState } from 'react';

import { deleteIcon } from '@assets';

export interface ReportTabProps {
  form: UseFormReturnType<any>;
  editDisabled: boolean;
}

export const ReportTab: React.FC<ReportTabProps> = ({ form, editDisabled }) => {
  const [deleteTraceIdx, setDeleteTraceIdx] = useState(null);

  const handleTraceDelete = (traceIdx: number) => {
    const newTrace = form?.values?.trace.filter((_, idx) => idx !== traceIdx);
    form.setFieldValue('trace', newTrace);
    form.setFieldValue('UnloadingRemark.conform', Number(form.values.UnloadingRemark?.stateOfSeals !== '0' && !newTrace?.length).toString());
    setDeleteTraceIdx(null);
  };

  return (
    <Stack gap="md" w={1000}>
      <Grid data-pw="report-header">
        <Grid.Col span={7.5}>
          <Text truncate="start" fw={600}>
            Path
          </Text>
        </Grid.Col>
        <Grid.Col span={2}>
          <Text truncate="start" fw={600}>
            Initial value
          </Text>
        </Grid.Col>
        <Grid.Col span={2}>
          <Text truncate="start" fw={600}>
            New value
          </Text>
        </Grid.Col>
        <Grid.Col span={0.5}></Grid.Col>
      </Grid>

      {form.values.trace
        ?.filter((trace) => !trace.ignore)
        ?.map((trace, traceIdx) => (
          <Grid key={trace.path} data-pw={`trace-row-${trace.path}`}>
            <Grid.Col span={7.5}>
              <Tooltip label={trace.path} color="blue" disabled={trace.path.length < 70}>
                <Text truncate="start">{trace.path}</Text>
              </Tooltip>
            </Grid.Col>
            <Grid.Col span={2}>
              <Tooltip label={trace.initialValue} color="blue" disabled={(trace.initialValue?.length || 0) < 20}>
                <Text truncate="start">{trace.initialValue || 'N/A'}</Text>
              </Tooltip>
            </Grid.Col>
            <Grid.Col span={2}>
              <Tooltip label={trace.newValue} color="blue" disabled={(trace.newValue?.length || 0) < 20}>
                <Text truncate="start">{trace.newValue || 'N/A'}</Text>
              </Tooltip>
            </Grid.Col>
            {!editDisabled && (
              <Grid.Col span={0.5}>
                <UnstyledButton ml={10} w={20} h={20} type="button" onClick={() => setDeleteTraceIdx(traceIdx)}>
                  <img src={deleteIcon} alt="Remove" />
                </UnstyledButton>
              </Grid.Col>
            )}
          </Grid>
        ))}

      {deleteTraceIdx !== null && (
        <Modal title="Delete trace item" opened={true} onClose={() => setDeleteTraceIdx(null)} centered zIndex={9999}>
          <Text>Are you sure you want to delete this trace item?</Text>

          <Group justify="center" mt="xl">
            <Button variant="outline" onClick={() => setDeleteTraceIdx(null)}>
              Cancel
            </Button>
            <Button data-pw="delete-trace-item-btn" variant="filled" color="red" onClick={() => handleTraceDelete(deleteTraceIdx)}>
              Delete
            </Button>
          </Group>
        </Modal>
      )}
    </Stack>
  );
};
